import { APITypesV1 } from "@cur8/api-client";
import { skipToken, useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { useAPIClient } from "render/context/APIContext";
import { ExtractBody, ExtractKey, QueryOptions } from "typings/query";

type Body = ExtractBody<typeof queryFn>;
type Key = ExtractKey<typeof queryKey>;

export function useLatestTimelineEventQuery<T = Body>({
  patientId,
  visitId,
  options,
}: {
  patientId: string | null | undefined;
  visitId: string | null | undefined;
  options?: QueryOptions<Body, Key, T>;
}) {
  const apiClient = useAPIClient();

  return useQuery({
    ...options,
    queryKey: queryKey(patientId, visitId),
    queryFn:
      patientId != null && visitId != null
        ? queryFn(apiClient, patientId, visitId)
        : skipToken,
  });
}

const queryKey = (
  patientId: string | null | undefined,
  visitId: string | null | undefined
) => ["latest-timeline-event", patientId, visitId] as const;

const queryFn =
  (apiClient: APIClient, patientId: string, visitId: string) =>
  (): Promise<APITypesV1.TimelineEventDto> =>
    apiClient.timeline.fetchLatestTimelineEvent({ patientId, visitId }).result;
